import { UnSaveGuard } from '@qima-labs/app/shared/guards/unsave.guard';
import { ERouters } from '@qima-labs/app/shared/models/enums/routers.enum';
import { Route } from '@angular/router';

export const TEST_SETUP_ROUTES: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: `${ERouters.TEST}`,
  },
  {
    path: `${ERouters.TEST}`,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./pages/test/test.component').then(m => m.TestComponent),
  },
  {
    path: `${ERouters.TEST_DETAIL}`,
    canDeactivate: [UnSaveGuard],
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./pages/test/shared/pages/test-detail/test-detail.component').then(m => m.TestDetailComponent),
    children: [
      {
        path: `:id`,
        pathMatch: 'full',
        redirectTo: `${ERouters.GENERAL_INFO}/:id`,
      },
      {
        path: `${ERouters.GENERAL_INFO}/:id`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/test/shared/pages/test-detail/pages/general-info/general-info.component').then(m => m.GeneralInfoComponent),
      },
      {
        path: `${ERouters.LAB_INFO}/:id`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/test/shared/pages/test-detail/pages/lab-info/lab-info.component').then(m => m.LabInfoComponent),
      },
      {
        path: `${ERouters.PARAMETER_INFO}/:id`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/test/shared/pages/test-detail/pages/parameter-info/parameter-info.component').then(m => m.ParameterInfoComponent),
      },
      {
        path: `${ERouters.LINKED_RESULT_TABLE}/:id`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () =>
          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
          import('./pages/test/shared/pages/test-detail/pages/link-result-table-container/link-result-table-container.component').then(m => m.LinkResultTableContainerComponent),
      },
      {
        path: `${ERouters.GENERAL_INFO}/${ERouters.AIMS_TO_LABS}/:id`,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        loadComponent: () => import('./pages/test/shared/pages/test-detail/pages/aims-to-labs/aims-to-labs.component').then(m => m.AimsToLabsComponent),
      },
    ],
  },
  {
    path: `${ERouters.MASTER_DATA}`,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./pages/master-data/master-data.component').then(m => m.MasterDataComponent),
  },
  {
    path: `${ERouters.PARAMETERS}`,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./pages/parameters/parameters.component').then(m => m.ParametersComponent),
  },
  {
    path: `${ERouters.TEST_METHOD}`,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./pages/test-method/test-method.component').then(m => m.TestMethodComponent),
  },
];
